import { ReactElement } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

type TProps = {
  noTitle?: boolean;
  showTimeFilter?: boolean;
  withCount?: boolean;
};

export const TimeFilterSkeleton = ({
  noTitle,
  showTimeFilter = true,
  withCount
}: TProps): ReactElement => {
  return (
    <div
      className={cc([
        'TimeFilter__skeleton',
        {
          'TimeFilter__skeleton--withCount': withCount
        }
      ])}
    >
      {!noTitle && (
        <Skeleton.Button className="TimeFilter__skeleton__title" active />
      )}
      {withCount && (
        <Skeleton.Button className="TimeFilter__skeleton__count" active />
      )}

      {showTimeFilter && (
        <Skeleton.Button className="TimeFilter__skeleton__filter" active />
      )}
    </div>
  );
};
